import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LABELS_FR = {
    count: 'Nombre'
};

const CustomLineChart = ({ data, title, dataKeys, colors }) => {
    return (
        <div style={{
            background: 'white',
            borderRadius: '10px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            margin: '10px',
            flex: 1
        }}>
            <h3 style={{ marginBottom: '20px', color: '#333' }}>{title}</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip formatter={(value, name) => [value, LABELS_FR[name] || name]} />
                    <Legend formatter={(value) => LABELS_FR[value] || value} />
                    {dataKeys.map((key, idx) => (
                        <Line key={key} type="monotone" dataKey={key} stroke={colors[idx % colors.length]} strokeWidth={2} />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default CustomLineChart;